import _ from 'lodash';

class TableSearchController {
  constructor(formValidationService) {
    this.name = 'tableSearch';
    this.formValidationService = formValidationService;
  }

  submit(formName) {
    if (formName.$valid) {
      this.setFormErrorMessageDefaults();
      this.search();
    } else {
      this.formValidationService.touchFormFields(formName);
    }
  }

  setFormErrorMessageDefaults(excludeKey) {
    _.map(this.metaData[this.options.dataSet].search.errors, (value, key) => {
      this.metaData[this.options.dataSet].search.errors[key] = key === excludeKey ? true : false;
    });
  }

  setFormErrorMessagesForKey(formName, formField) {
    let isFieldLessThanMinlength = this.formValidationService.isFormFieldErroneous(formName, formField) && this.formValidationService.isFieldLessThanMinlength(formName, formField);
    let isFieldExceedingMaxlength = this.formValidationService.isFormFieldErroneous(formName, formField) && this.formValidationService.isFieldExceedingMaxlength(formName, formField);

    if (isFieldLessThanMinlength) {
      this.setFormErrorMessageDefaults('SEARCH_FIELD_MINLENGTH_ERROR');
    }

    if (isFieldExceedingMaxlength) {
      this.setFormErrorMessageDefaults('SEARCH_FIELD_MAXLENGTH_ERROR');
    }
  }
}

TableSearchController.$inject = ['formValidationService'];

export
default TableSearchController;


// WEBPACK FOOTER //
// ./app/components/tableSearch/tableSearch.controller.js